import { Length, MaxString, ModelBase, NormalLength, Property, Required, ShortLength, VeryLongString } from '@skylab-shared/core';
import { head } from '@skylab-shared/utils';
import { DiscountKind } from '../common/discount-kind';
import { DocumentItemAmountsSource } from '../document/document-item-amounts-source';

export class PurchaseEInvoiceDocumentItemModel extends ModelBase {
    @Property({nullable: true})
    public zal15: boolean;

    @Property({ nullable: true })
    @Length({ max: ShortLength }, 'data-model.product.validation.bar-code.length')
    public barCode: string;

    @Property({ nullable: true })
    @Length({ max: ShortLength }, 'data-model.product.validation.symbol.length')
    public symbol: string;

    @Property({nullable: true})
    public readonly adjusted: boolean;

    @Property({nullable: true})
    public readonly amountsSource: DocumentItemAmountsSource;

    @Property()
    public readonly id?: number;

    @Property(String, {nullable: true})
    @Length({ max: ShortLength }, 'data-model.document-item.validation.cn-code.length')
    public cnCode: string | null;

    @Property(String, { nullable: true})
    @Length({ max: NormalLength }, 'data-model.document-item.validation.pkwiu.length')
    public pkwiu: string | null;

    @Property(String, {nullable: true})
    @MaxString('data-model.document-item.validation.note.length')
    public note: string | null;

    @Property()
    public ordinalNumber: number;

    @Property({nullable: true})
    public discountValue: number;

    @Property({nullable: true})
    public discountKind: DiscountKind;

    @Property(Number, { nullable: true })
    public productId: number | null;

    @Property(String, {nullable: true})
    @VeryLongString('data-model.purchase-e-invoice.validation.name.length')
    @Required('data-model.document-item.validation.name.not-empty')
    public productName: string | null;

    @Property({nullable: true})
    public quantity: number;

    @Property({nullable: true})
    public unitId: number;

    @Property()
    public unitSymbol: string;

    @Property({nullable: true})
    public price_grossAfterDiscount: number;

    @Property({nullable: true})
    public price_grossBeforeDiscount: number;

    @Property({nullable: true})
    public price_netAfterDiscount: number;

    @Property({nullable: true})
    public price_netBeforeDiscount: number;

    @Property({nullable: true})
    public value_grossAfterDiscount: number;

    @Property({nullable: true})
    public value_grossBeforeDiscount: number;

    @Property({nullable: true})
    public value_netAfterDiscount: number;

    @Property({nullable: true})
    public value_netBeforeDiscount: number;

    @Property({nullable: true})
    public value_vatAfterDiscount: number;

    @Property({nullable: true})
    public value_vatBeforeDiscount: number;

    @Property({nullable: true})
    public vatRateId: number;

    @Property()
    public jpkVatGroups: string[];

    public get jpkVatGroup(): string {
        return head(this.jpkVatGroups);
    }

    public set jpkVatGroup(value: string) {
        this.jpkVatGroups = value ? [value] : [];
    }
}
